<template>
  <div class="wrapper">
    <section class="answer-one answer">
      <div class="container answer__container">
        <div class="answer__block--title-two">
          <span class="levels__love-bg">
            <picture>
              <source srcset="~@/assets/img/level-love-2.avif" type="image/avif">
              <source srcset="~@/assets/img/level-love-2.webp" type="image/webp">
              <img loading="lazy" src="~@/assets/img/level-love-2.png" class="image" width="54" height="166" alt="Love">
            </picture>
          </span>
          <h2 class="answer__title">Уровень 2</h2>
          <p class="answer__subtitle">Низкий:</p>
        </div>
        <div class="answer__content">
          <div class="process-bar__label">Потенциал любовной энергии</div>
          <div class="process-bar">
            <div class="process-bar__line result-2"></div>
            <div class="process-bar__value">92%</div>
          </div>
          <div class="process-bar-listing">
            <div class="process-bar-listing__title">Любовная энергия на данный момент:</div>
            <div class="process-bar-list__label">Любовь к себе</div>
            <div class="process-bar-list">
              <div class="process-bar-list__line result-2_list_1"></div>
              <div class="process-bar-list__value">13%</div>
            </div>
            <div class="process-bar-list__label">Любовь к окружающим </div>
            <div class="process-bar-list">
              <div class="process-bar-list__line result-2_list_2"></div>
              <div class="process-bar-list__value">15%</div>
            </div>
            <div class="process-bar-list__label">Любовь к жизни</div>
            <div class="process-bar-list">
              <div class="process-bar-list__line result-2_list_3"></div>
              <div class="process-bar-list__value">17%</div>
            </div>
          </div>
          <div class="text-icon">
            <img src="@/assets/img/svg/icon_1_text.svg" />
            <p>У вас довольно большой потенциал любовной энергии! С “правильным”
              и подходящим человеком
              <span>у вас есть все шансы раскрыть этот потенциал</span> до максимума и создать крепкий и счастливый союз. </p>
          </div>
          <p class="answer__content--text">Вы не боитесь трудностей и готовы стараться ради своих отношений. Однако сейчас уровень вашей энергии любви низкий. В глубине души вы можете ощущать себя несчастной или одинокой, это нормально для вашего уровня,
            но с этим необходимо бороться.<br/><br/>
            На данном этапе жизни вы склонны привлекать не понимающих вас партнеров, рядом с которыми вы часто оказываетесь в позиции жертвы и не получаете достаточно эмоциональной отдачи. Причина
            в том, что у вас неверная установка на счет себя, вы не разрешаете себе быть с партнером, который заслуживает вас и вашей любви,
            а довольствуетесь малым.
          </p>
          <div class="text-icon icon-top m28">
            <img src="@/assets/img/svg/icon_2_text.svg" />
            <p>Если вы не начнете повышать свой уровень любовной энергии, эта негативная установка постоянно будет мешать вам строить отношения. </p>
          </div>
          <p class="answer__content--text no-margin">Потому что <span>ваше недовольство собой не позволит мужчине оценить вас по-настоящему
            и увидеть перед собой самодостаточную личность, которой вы являетесь.</span> </p>
          <p class="answer__content--text m28">Вам необходимо поверить в себя и в собственные силы, не соглашаться на все, что вам предлагают, а самой делать выбор. Только так вы сможете поднять свой уровень энергии любви. </p>
          <div class="block-text">
            <div class="block-text__title">Высокий уровень любви даст вам:</div>
            <div class="block-text__text">— здоровую самооценку;
            </div>
            <div class="block-text__text">
              — умение любить себя такой, какая вы есть;
            </div>
            <div class="block-text__text">
              — способность быть любимой;
            </div>
            <div class="block-text__text">
              — счастливые отношения;
            </div>
            <div class="block-text__text">
              — внутреннее равновесие;
            </div>
            <div class="block-text__text">
              — избавление от одиночества.
            </div>
          </div>

          <div class="rs-title">Персональные рекомендации для вас:</div>
          <div class="rs-block">
            <div class="rs-block__table">
              <div class="rs-block__number">01</div>
              <div class="rs-block__subtitle">Аффирмации для повышения собственной значимости. </div>
            </div>
            <div class="rs-block__text">Каждый день повторяйте перед зеркалом: “Я важна для себя и для мира. Я нужна себе и миру. Я делаю правильный выбор. Я сама в ответе за свою судьбу. Я могу все изменить. Я меняю свою жизнь к лучшему и несу за это ответственность”. </div>
          </div>
          <div class="rs-block">
            <div class="rs-block__table">
              <div class="rs-block__number">02</div>
              <div class="rs-block__subtitle icon_number"> Амулет
                <br />“Энергия любви”.</div>
            </div>
            <div class="rs-block__text icon_end">Руническая формула такого браслета в первую очередь работает над самооценкой и самоценностью владельца. Она настроит вашу энергетику на осознание своей значимости, понимание важности <br>своих желаний и потребностей. Как работает амулет и чем он вам <br>поможет — читайте тут
            </div>
            <div class="more">
              <a class="info__button btn_rs btn" :href="url" onclick="ym(56736205,'reachGoal','amuletslovetest')">Заказать амулет</a>
            </div>
          </div>
          <div class="rs-block">
            <div class="rs-block__table">
              <div class="rs-block__number">03</div>
              <div class="rs-block__subtitle">“Дневник выбора”.</div>
            </div>
            <div class="rs-block__text">Ежедневно записывайте в специальный блокнот все выборы, которые сделали за день: будь то утренний кофе из автомата или наряд на работу. Напротив тех выборов, которые вы сделали самостоятельно, ставьте галочку. Старайтесь каждый день делать свой собственный, не навязанный кем-то другим выбор. Регулярные записи помогут вам поверить, что вы способны менять свою жизнь без оглядки на других!</div>
          </div>
        </div>
      </div>
    </section>
    <FooterResult />
  </div>
</template>

<script>
import FooterResult from "@/components/FooterResult";
export default {
  name: "Result2",
  components: {FooterResult},
  computed: {
    utm() {
      return this.$store.getters['utm']
    },
    url() {
      let link = 'https://store.taroirena.ru/shop/amulety/braslet-energiya-lyubvi/'
      if(this.utm.utm_source) {
        link += '?utm_source=' + this.utm.utm_source
      }
      if(this.utm.utm_medium) {
        link += '&utm_medium=' + this.utm.utm_medium
      }
      if(this.utm.utm_campaign) {
        link += '&utm_campaign=' + this.utm.utm_campaign
      }
      if(this.utm.utm_content) {
        link += '&utm_content=' + this.utm.utm_content
      }
      if(this.utm.utm_term) {
        link += '&utm_term=' + this.utm.utm_term
      }
      return link
    }
  }
}
</script>